export const adConfig = {
  bufferTime: 0.915, // Default buffer time
  introSplashDuration: 3, // Approximate duration of the intro splash
  timerIncrement: 1000 // Timer increment in milliseconds
};
